export default "__VITE_ASSET__0226ca2c__"